import { chakra } from "@chakra-ui/system"

export function ApplePodcast(props: any) {
  return (
    <chakra.svg viewBox="0 0 300 300" {...props}>
      <linearGradient
        id="prefix__a"
        gradientUnits="userSpaceOnUse"
        x1={150}
        y1={0}
        x2={150}
        y2={300}
      >
        <stop offset={0} stopColor="#f452ff" />
        <stop offset={1} stopColor="#832bc1" />
      </linearGradient>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#prefix__a)"
        d="M294.1 260c-2.9 7.4-9.6 17.8-19.2 25.2-5.5 4.2-12.1 8.3-21.1 11-9.6 2.9-21.5 3.8-36.3 3.8h-135c-14.8 0-26.6-1-36.3-3.8-9-2.7-15.6-6.7-21.1-11-9.5-7.3-16.3-17.8-19.2-25.2C.1 245.1 0 228.2 0 217.5v-135C0 71.8.1 54.9 5.9 40c2.9-7.4 9.6-17.8 19.2-25.2 5.5-4.2 12.1-8.3 21.1-11C55.9 1 67.7 0 82.5 0h135c14.8 0 26.6 1 36.3 3.8 9 2.7 15.6 6.7 21.1 11 9.5 7.3 16.3 17.8 19.2 25.2 5.9 14.9 5.9 31.9 5.9 42.5v135c0 10.7-.1 27.6-5.9 42.5z"
      />
      <g fill="#FFF">
        <path d="M175.7 181.1c-.4-3.6-1.6-6.2-4-8.6-4.5-4.7-12.4-7.8-21.7-7.8-9.3 0-17.2 3-21.7 7.8-2.3 2.5-3.6 5-4 8.6-.8 7-.3 13 .5 22.7.8 9.2 2.3 21.5 4.2 33.9 1.4 8.9 2.5 13.7 3.5 17.1 1.7 5.6 7.8 10.4 17.5 10.4s15.9-4.9 17.5-10.4c1-3.4 2.1-8.2 3.5-17.1 1.9-12.5 3.4-24.7 4.2-33.9.9-9.7 1.3-15.7.5-22.7zM174.6 130.1c0 13.6-11 24.6-24.6 24.6s-24.6-11-24.6-24.6c0-13.6 11-24.6 24.6-24.6s24.6 11.1 24.6 24.6z" />
        <path d="M149.7 33.2C92.3 33.4 45.3 80 44.5 137.4c-.6 46.5 29.1 86.3 70.6 100.9 1 .4 2-.5 1.9-1.5-.5-3.6-1.1-7.2-1.5-10.8-.2-1.3-1-2.3-2.1-2.9-32.8-14.3-55.7-47.2-55.3-85.3.5-50 41.3-90.7 91.2-91.1 51.1-.4 92.8 41 92.8 92 0 37.7-22.8 70.1-55.3 84.4-1.2.5-2 1.6-2.1 2.9l-1.5 10.8c-.2 1.1.9 1.9 1.9 1.5 41.1-14.4 70.6-53.6 70.6-99.6-.2-58.2-47.7-105.6-106-105.5z" />
        <path d="M147.3 68.2c-37.4 1.4-67.4 32.3-67.9 69.7-.3 24.6 12 46.4 30.9 59.3.9.6 2.2-.1 2.2-1.2-.3-4.3-.3-8.1-.1-12.1.1-1.3-.4-2.5-1.4-3.4-11.5-10.8-18.5-26.2-18.1-43.2.8-30 24.9-54.4 54.9-55.6 32.6-1.3 59.4 24.9 59.4 57.1 0 16.4-7 31.2-18.1 41.7-.9.9-1.4 2.1-1.4 3.4.2 3.9.1 7.7-.1 12-.1 1.1 1.2 1.9 2.2 1.2 18.6-12.7 30.9-34.2 30.9-58.4.1-39.8-33.2-72.1-73.4-70.5z" />
      </g>
    </chakra.svg>
  );
}


